// extracted by mini-css-extract-plugin
export var banner = "_s8-0";
export var settingRow = "_s8-2";
export var titleIcon = "_s8-1";